import { DATE_FORMAT_SERVER, ENDPOINTS, JobTitle, Status } from '@constants';
import { Prototype } from '@core';
import { useFetchDashboardOperationTripSummary } from '@hooks';
import TotalCard from '@pages/Dashboard/components/TotalCard';
import { FormatterUtils } from '@utils';
import { map } from 'lodash';
import React, { memo, useState } from 'react';
import trans from 'translation';
import { KChip, KContainer, KGrid, KInput } from 'uikit';

interface IProps {
  currentDate: Date;
}

const TripSummary = ({ currentDate }: IProps) => {
  const [drivers, setDriver] = useState<any[]>([]);

  const { data, isLoading } = useFetchDashboardOperationTripSummary(
    Prototype.date
      .toMoment(currentDate.toISOString())
      ?.format(DATE_FORMAT_SERVER) ?? '',
    map(drivers, 'id') ?? []
  );

  // const props = useMemo(() => {
  //   return [
  //     {
  //       paid: 160,
  //       overdue: 37,
  //       balance_due: 64
  //     },
  //     {
  //       paid: 88,
  //       overdue: 77,
  //       balance_due: 32
  //     },
  //     {
  //       paid: 60,
  //       overdue: 18,
  //       balance_due: 78
  //     }
  //   ];
  // }, []);

  // const driverLabels = useMemo(
  //   () => props.map((_, index) => `Driver ${index + 1}`),
  //   [props]
  // );

  // const labels = useMemo(() => [150, 300, 450, 600], []);
  // const values1 = useMemo(() => [100, 200, 300, 400], []);
  // const values2 = useMemo(() => [150, 200, 240, 350], []);
  // const values3 = useMemo(() => [120, 240, 350, 400], []);
  // const values4 = useMemo(() => [50, 300, 200, 100], []);

  // const tripsLineData = useMemo(() => {
  //   return {
  //     // labels: driverLabels,
  //     labels: labels,
  //     datasets: [
  //       {
  //         label: trans('numbers_of_trips'),
  //         data: labels.map((_, i) => values1[i % values1.length]),
  //         borderColor: '#13A89E',
  //         backgroundColor: '#13A89E'
  //       },
  //       {
  //         label: trans('container_trips'),
  //         data: labels.map((_, i) => values2[i % values2.length]),
  //         borderColor: '#3120F0',
  //         backgroundColor: '#3120F0'
  //       },
  //       {
  //         label: trans('connection_trips'),
  //         data: labels.map((_, i) => values3[i % values3.length]),
  //         borderColor: '#20D4F0',
  //         backgroundColor: '#20D4F0'
  //       },
  //       {
  //         label: trans('futile_trips'),
  //         data: labels.map((_, i) => values4[i % values4.length]),
  //         borderColor: '#F09D20',
  //         backgroundColor: '#F09D20'
  //       }
  //     ]
  //   };
  // }, [labels, values1, values2, values3, values4]);
  // const hoursLineData = useMemo(() => {
  //   return {
  //     // labels: driverLabels,
  //     labels: labels,
  //     datasets: [
  //       {
  //         label: trans('daily_hours'),
  //         data: labels.map((_, i) => values1[i % values1.length]),
  //         borderColor: '#13A89E',
  //         backgroundColor: '#13A89E'
  //       },
  //       {
  //         label: trans('container_trips_hours'),
  //         data: labels.map((_, i) => values2[i % values2.length]),
  //         borderColor: '#3120F0',
  //         backgroundColor: '#3120F0'
  //       },
  //       {
  //         label: trans('connection_trips_hours'),
  //         data: labels.map((_, i) => values3[i % values3.length]),
  //         borderColor: '#20D4F0',
  //         backgroundColor: '#20D4F0'
  //       }
  //     ]
  //   };
  // }, [labels, values1, values2, values3]);

  // const tripsOptions = {
  //   responsive: true,
  //   interaction: {
  //     mode: 'index' as const,
  //     intersect: false
  //   },
  //   stacked: false,
  //   plugins: {
  //     legend: {
  //       position: 'bottom' as const,
  //       labels: {
  //         boxWidth: 12,
  //         padding: 20
  //       },
  //       display: true
  //     },
  //     tooltip: {
  //       mode: 'index' as const,
  //       intersect: false
  //     }
  //   },
  //   scales: {
  //     y: {
  //       type: 'linear' as const,
  //       display: true,
  //       position: 'left' as const,
  //       title: {
  //         display: true,
  //         text: 'Trips'
  //       }
  //     }
  //   }
  // };
  // const hoursOptions = {
  //   responsive: true,
  //   interaction: {
  //     mode: 'index' as const,
  //     intersect: false
  //   },
  //   stacked: false,
  //   plugins: {
  //     legend: {
  //       position: 'bottom' as const,
  //       labels: {
  //         boxWidth: 12,
  //         padding: 20
  //       },
  //       display: true
  //     },
  //     tooltip: {
  //       mode: 'index' as const,
  //       intersect: false
  //     }
  //   },
  //   scales: {
  //     y: {
  //       type: 'linear' as const,
  //       display: true,
  //       position: 'left' as const,
  //       title: {
  //         display: true,
  //         text: 'Hours'
  //       }
  //     }
  //   }
  // };

  return (
    <KGrid.Container>
      <KGrid.Item xs={12}>
        <KContainer.View width={'fit-content'} paddingV={'0.5rem'}>
          <KInput.Autocomplete
            style={{
              minWidth: 300
            }}
            label={trans('driver')}
            apiURL={ENDPOINTS.staff()}
            value={drivers}
            onChange={(v: any) => setDriver(v)}
            apiParams={{
              jobTitle: JobTitle.Driver
            }}
            multiple
            renderTags={(tagValue, getTagProps) => {
              return tagValue?.map((i: any, index) => {
                const isActive = i?.status === Status.Active;
                return (
                  <KChip
                    key={i.id}
                    {...getTagProps({ index })}
                    label={i.displayName}
                    isLink
                    onPress={() => {
                      window.open(`/admin/staff/${i.id}`);
                    }}
                    color={isActive ? undefined : 'secondary'}
                  />
                );
              });
            }}
            // isInitFetch
            getOptionLabel={FormatterUtils.staff}
            hasAddNew
            addNewKey="displayName"
            addNewURL="staff"
            hasEdit
            editURL="staff"
          />
        </KContainer.View>
      </KGrid.Item>
      <KGrid.Item xs={4}>
        <TotalCard
          icon="HomeWork"
          iconStyle={{ fontSize: 60, color: '#3120F0' }}
          label={trans('container_trips')}
          value={(data as any)?.numOfContainerTrips}
          isLoading={isLoading}
        />
      </KGrid.Item>
      <KGrid.Item xs={4}>
        <TotalCard
          icon="Work"
          iconStyle={{ fontSize: 60, color: '#20D4F0' }}
          label={trans('connection_trips')}
          value={(data as any)?.numOfConnectionTrips}
          isLoading={isLoading}
        />
      </KGrid.Item>
      <KGrid.Item xs={4}>
        <TotalCard
          icon="LocalShipping"
          iconStyle={{ fontSize: 60, color: '#F09D20' }}
          label={trans('futile_trips')}
          value={(data as any)?.numOfFutileTrips}
          isLoading={isLoading}
        />
      </KGrid.Item>
      {/* <KContainer.View
          height="100%"
          marginT={0}
          dp="flex"
          alignItems="stretch"
          flexG={1}
        >
          <KContainer.View>
            <KGrid.Container spacing={2} alignItems="stretch">
              <KGrid.Item xs={5}>
                <KInput.Autocomplete
                  label={trans('driver')}
                ></KInput.Autocomplete>
              </KGrid.Item>
              <KGrid.Item xs={5}></KGrid.Item>
              <KGrid.Item xs={2}>
                <KButton.Solid marginL="1rem" title="Apply" />
              </KGrid.Item>
            </KGrid.Container>
          </KContainer.View>
  
          <KContainer.View
            flex
            style={{
              overflowY: 'auto',
              overflowX: 'hidden'
            }}
          >
            <KGrid.Container
              spacing={2}
              alignItems="stretch"
              style={{ height: '100%' }}
            >
              <KGrid.Item xs={8}>
                <KContainer.View
                  marginT="1rem"
                  padding="1rem"
                  style={{
                    border: '1px solid #ccc',
                    borderRadius: '1rem',
                    background: '#fff'
                  }}
                  overflow
                >
                  <KContainer.View
                    row
                    alignItems
                    justifyContent="space-between"
                    width="100%"
                  >
                    <KLabel.Text marginR="2rem" typo="TextLgBold">
                      {trans('trips_by_trip_type')}
                    </KLabel.Text>
                    <select
                      value={displayMode}
                      onChange={e =>
                        setDisplayMode(
                          e.target.value as
                            | 'daily'
                            | 'weekly'
                            | 'monthly'
                            | 'yearly'
                        )
                      }
                      style={{
                        padding: '0.25rem 2rem',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        background: 'white'
                      }}
                    >
                      <option value="daily">{trans('Daily')}</option>
                      <option value="weekly">{trans('Weekly')}</option>
                      <option value="monthly">{trans('Monthly')}</option>
                      <option value="yearly">{trans('Yearly')}</option>
                    </select>
                  </KContainer.View>
                  <KContainer.View marginT="1rem" style={{ height: '280px' }}>
                    <Line data={tripsLineData} options={tripsOptions} />
                  </KContainer.View>
                </KContainer.View>
              </KGrid.Item>
  
              <KGrid.Item xs={4}>
                <KGrid.Container spacing={2}>
                  <KGrid.Item xs={12}>
                    <KContainer.View
                      marginT="1rem"
                      padding="1rem"
                      style={{
                        border: '1px solid #ccc',
                        borderRadius: '1rem',
                        background: '#fff'
                      }}
                    >
                      <KGrid.Container spacing={2}>
                        <KGrid.Item xs={5}>
                          <HomeWorkIcon
                            style={{ fontSize: 60, color: '#3120F0' }}
                          />
                        </KGrid.Item>
                        <KGrid.Item xs={7}>
                          <KGrid.Container spacing={2}>
                            <KGrid.Item xs={12}>
                              <KContainer.View
                                style={{ marginLeft: 'auto' }}
                                row
                                alignItems
                                marginL="1rem"
                              >
                                <KLabel.Text marginR="2rem" typo="TextMdNormal">
                                  {trans('container_trips')}
                                </KLabel.Text>
                              </KContainer.View>
                            </KGrid.Item>
                            <KGrid.Item xs={12}>
                              <KContainer.View
                                style={{ marginLeft: 'auto' }}
                                row
                                alignItems
                              >
                                <KLabel.Text marginL="2rem" typo="TextXLgBold">
                                  5
                                </KLabel.Text>
                              </KContainer.View>
                            </KGrid.Item>
                          </KGrid.Container>
                        </KGrid.Item>
                      </KGrid.Container>
                    </KContainer.View>
                  </KGrid.Item>
  
                  <KGrid.Item xs={12}>
                    <KContainer.View
                      padding="1rem"
                      style={{
                        border: '1px solid #ccc',
                        borderRadius: '1rem',
                        background: '#fff'
                      }}
                    >
                      <KGrid.Container spacing={2}>
                        <KGrid.Item xs={5}>
                          <WorkIcon style={{ fontSize: 60, color: '#20D4F0' }} />
                        </KGrid.Item>
                        <KGrid.Item xs={7}>
                          <KGrid.Container spacing={2}>
                            <KGrid.Item xs={12}>
                              <KContainer.View
                                style={{ marginLeft: 'auto' }}
                                row
                                alignItems
                                marginL="1rem"
                              >
                                <KLabel.Text marginR="2rem" typo="TextMdNormal">
                                  {trans('connection_trips')}
                                </KLabel.Text>
                              </KContainer.View>
                            </KGrid.Item>
                            <KGrid.Item xs={12}>
                              <KContainer.View
                                style={{ marginLeft: 'auto' }}
                                row
                                alignItems
                              >
                                <KLabel.Text marginL="2rem" typo="TextXLgBold">
                                  5
                                </KLabel.Text>
                              </KContainer.View>
                            </KGrid.Item>
                          </KGrid.Container>
                        </KGrid.Item>
                      </KGrid.Container>
                    </KContainer.View>
                  </KGrid.Item>
  
                  <KGrid.Item xs={12}>
                    <KContainer.View
                      padding="1rem"
                      style={{
                        border: '1px solid #ccc',
                        borderRadius: '1rem',
                        background: '#fff'
                      }}
                    >
                      <KGrid.Container spacing={2}>
                        <KGrid.Item xs={5}>
                          <LocalShippingIcon
                            style={{ fontSize: 60, color: '#F09D20' }}
                          />
                        </KGrid.Item>
                        <KGrid.Item xs={7}>
                          <KGrid.Container spacing={2}>
                            <KGrid.Item xs={12}>
                              <KContainer.View
                                style={{ marginLeft: 'auto' }}
                                row
                                alignItems
                                marginL="1rem"
                              >
                                <KLabel.Text marginR="2rem" typo="TextMdNormal">
                                  {trans('futile_trips')}
                                </KLabel.Text>
                              </KContainer.View>
                            </KGrid.Item>
                            <KGrid.Item xs={12}>
                              <KContainer.View
                                style={{ marginLeft: 'auto' }}
                                row
                                alignItems
                              >
                                <KLabel.Text marginL="2rem" typo="TextXLgBold">
                                  5
                                </KLabel.Text>
                              </KContainer.View>
                            </KGrid.Item>
                          </KGrid.Container>
                        </KGrid.Item>
                      </KGrid.Container>
                    </KContainer.View>
                  </KGrid.Item>
                </KGrid.Container>
              </KGrid.Item>
  
              <KGrid.Item xs={8}>
                <KContainer.View
                  marginT="1rem"
                  padding="1rem"
                  style={{
                    border: '1px solid #ccc',
                    borderRadius: '1rem',
                    background: '#fff'
                  }}
                >
                  <KContainer.View style={{ marginLeft: 'auto' }} row alignItems>
                    <KLabel.Text marginR="2rem" typo="TextLgBold">
                      {trans('hours_by_daily')}
                    </KLabel.Text>
                  </KContainer.View>
                  <KContainer.View marginT="1rem" style={{ height: '320px' }}>
                    <Line data={hoursLineData} options={hoursOptions} />
                  </KContainer.View>
                </KContainer.View>
              </KGrid.Item>
  
              <KGrid.Item xs={4}>
                <KGrid.Container spacing={2}>
                  <KGrid.Item xs={12}>
                    <KContainer.View
                      marginT="1rem"
                      padding="1rem"
                      style={{
                        border: '1px solid #ccc',
                        borderRadius: '1rem',
                        background: '#fff'
                      }}
                    >
                      <KGrid.Container spacing={2}>
                        <KGrid.Item xs={5}>
                          <QueryBuilderIcon
                            style={{ fontSize: 60, color: '#13A89E' }}
                          />
                        </KGrid.Item>
                        <KGrid.Item xs={7}>
                          <KGrid.Container spacing={2}>
                            <KGrid.Item xs={12}>
                              <KContainer.View
                                style={{ marginLeft: 'auto' }}
                                row
                                alignItems
                                marginL="1rem"
                              >
                                <KLabel.Text marginR="2rem" typo="TextMdNormal">
                                  {trans('total_daily_hours')}
                                </KLabel.Text>
                              </KContainer.View>
                            </KGrid.Item>
                            <KGrid.Item xs={12}>
                              <KContainer.View
                                style={{ marginLeft: 'auto' }}
                                row
                                alignItems
                              >
                                <KLabel.Text marginL="2rem" typo="TextXLgBold">
                                  5
                                </KLabel.Text>
                              </KContainer.View>
                            </KGrid.Item>
                          </KGrid.Container>
                        </KGrid.Item>
                      </KGrid.Container>
                    </KContainer.View>
                  </KGrid.Item>
  
                  <KGrid.Item xs={12}>
                    <KContainer.View
                      padding="1rem"
                      style={{
                        border: '1px solid #ccc',
                        borderRadius: '1rem',
                        background: '#fff'
                      }}
                    >
                      <KGrid.Container spacing={2}>
                        <KGrid.Item xs={5}>
                          <HomeWorkIcon
                            style={{ fontSize: 60, color: '#3120F0' }}
                          />
                        </KGrid.Item>
                        <KGrid.Item xs={7}>
                          <KGrid.Container spacing={2}>
                            <KGrid.Item xs={12}>
                              <KContainer.View
                                style={{ marginLeft: 'auto' }}
                                row
                                alignItems
                                marginL="1rem"
                              >
                                <KLabel.Text marginR="2rem" typo="TextMdNormal">
                                  {trans('container_trips_hours')}
                                </KLabel.Text>
                              </KContainer.View>
                            </KGrid.Item>
                            <KGrid.Item xs={12}>
                              <KContainer.View
                                style={{ marginLeft: 'auto' }}
                                row
                                alignItems
                              >
                                <KLabel.Text marginL="2rem" typo="TextXLgBold">
                                  5
                                </KLabel.Text>
                              </KContainer.View>
                            </KGrid.Item>
                          </KGrid.Container>
                        </KGrid.Item>
                      </KGrid.Container>
                    </KContainer.View>
                  </KGrid.Item>
  
                  <KGrid.Item xs={12}>
                    <KContainer.View
                      padding="1rem"
                      style={{
                        border: '1px solid #ccc',
                        borderRadius: '1rem',
                        background: '#fff'
                      }}
                    >
                      <KGrid.Container spacing={2}>
                        <KGrid.Item xs={5}>
                          <WorkIcon style={{ fontSize: 60, color: '#20D4F0' }} />
                        </KGrid.Item>
                        <KGrid.Item xs={7}>
                          <KGrid.Container spacing={2}>
                            <KGrid.Item xs={12}>
                              <KContainer.View
                                style={{ marginLeft: 'auto' }}
                                row
                                alignItems
                                marginL="1rem"
                              >
                                <KLabel.Text marginR="2rem" typo="TextMdNormal">
                                  {trans('connection_trips_hours')}
                                </KLabel.Text>
                              </KContainer.View>
                            </KGrid.Item>
                            <KGrid.Item xs={12}>
                              <KContainer.View
                                style={{ marginLeft: 'auto' }}
                                row
                                alignItems
                              >
                                <KLabel.Text marginL="2rem" typo="TextXLgBold">
                                  5
                                </KLabel.Text>
                              </KContainer.View>
                            </KGrid.Item>
                          </KGrid.Container>
                        </KGrid.Item>
                      </KGrid.Container>
                    </KContainer.View>
                  </KGrid.Item>
                </KGrid.Container>
              </KGrid.Item>
            </KGrid.Container>
          </KContainer.View>
        </KContainer.View> */}
    </KGrid.Container>
  );
};

export default memo(TripSummary);
